function isObject(e){return null!=e&&"object"==typeof e}module.exports=isObject;